import React from "react";
import { ProductContextProvider } from "../../context/product/ProductContext";
import { VariantContextProvider } from "../../context/variant/VariantContext";
import { SizingContextProvider } from "../../context/sizing/SizingContext";
import { fireSourcingLocationAnalytics } from "../../analytics/sourcingLocation";
import { useStockPrice } from "../../context/stockPrice/StockPriceContext";
import MixAndMatchProductCard from "../productCard/MixAndMatchProductCard";
import styles from "./MixAndMatchProducts.scss";
import classnamesBind from "classnames/bind";

const classnames = classnamesBind.bind(styles);

export default function MixAndMatchProducts() {
  const { products } = useStockPrice();

  const getMixAndMatchProducts = () => {
    return products.products.map((product, index) => (
      <ProductContextProvider
        products={products.products}
        productId={product.id}
        key={product.id}
      >
        <VariantContextProvider
          fireSourcingLocationAnalytics={fireSourcingLocationAnalytics}
        >
          <SizingContextProvider>
            <div
              className={classnames(styles.container, { first: index === 0 })}
              data-testid="mixAndMatchProducts"
            >
              <MixAndMatchProductCard index={index} />
            </div>
          </SizingContextProvider>
        </VariantContextProvider>
      </ProductContextProvider>
    ));
  };

  if (!products?.products?.length) {
    return null;
  }

  return (
    <div id="mix-and-match" data-testid="mix-and-match-items">
      {getMixAndMatchProducts()}
    </div>
  );
}
